<div class="container">
  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">
    <mat-tab label="Histórico Entradas" >
      <div  class="mt-4">
        <data-table
          title="Historico Entradas Inventario"
          [columns]='columnsII'
          [configuration]='configurationII'
          [reloadTable]='reloadTablaII'
          [params]='[]'
          [url]='urlTableII'
          (add)='addII($event)'
          (edit)='editII($event)'
          (view)='viewDetail($event)'
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>

    </mat-tab>
    <mat-tab *ngIf="selected.value == 1 || selected.value == 2" label="Entrada">
      <div style="width: 100%">

        <app-button-label [labelsEdit]="labels">
        </app-button-label>

        <data-table
          title="Entrada"
          [columns]="columnsDetails"
          [data]="dataDetails"
          [configuration]="configurationDetails"
          [reloadTable]="reloadTablaDetails"
          [headerFileXlsm]="headerDetailsFileXlsm"
        >
        </data-table>
      </div>
    </mat-tab>

    <mat-tab *ngIf="havePurchaseOrder && selected.value == 1 || selected.value == 2 " label="Detalle Orden de Compra">
      <app-carousel>
        <ng-template carouselItem="1">
          <mat-card class="mat-card-c" >
            <div class="d-flex justify-content-end">
              <div>
                <h4 *ngIf="dataPO.created" class="m-0 p-0 text-center font-weight-bold"
                  [style]="movil?'font-size: x-small; line-height: 0.6;':''"> Creación Solicitud</h4>
                <h3 class="m-0 p-0 text-center" [style]="movil?'font-size: x-small;':''">{{dataPO.created |
                  dateFormat}}</h3>
              </div>
            </div>
            <h2 style="display: flex; justify-content: center;"><strong>ORDEN DE COMPRA</strong></h2>
            <h3>Número de orden: {{dataPO.consecutive}}</h3>
            <h3 *ngIf="dataPO.comment != ''">Comentario: {{dataPO.comment}}</h3>
            <h3>Proveedor: {{dataPO.providerName}}</h3>
            <h3>Fecha de recepción: {{dataPO.receptionDate}}</h3>
            <h3>Costo: {{dataPO.totalCost | number:'1.0-0'}}</h3>
            <hr>
            <h2>Autorizó: {{dataPO.authorizeName}}</h2>
            <hr>
            <h3>Solicita: {{dataPO.requestsName}}</h3>
          </mat-card>

        </ng-template>

        <ng-template carouselItem="2">
          <mat-card class="mat-card-c">
            <h2 style="display: flex; justify-content: center;"><strong>RECURSOS</strong></h2>
            <data-table
              [title]=''
              [columns]='columnsDetails'
              [configuration]='configurationResoucesPO'
              [data]="dataResoucesPO">
            </data-table>
          </mat-card>
        </ng-template>
      </app-carousel>

    </mat-tab>

  </mat-tab-group>
 </div>
